import template from './uninvoicedTimeEntryModal.html';
import controller from './uninvoicedTimeEntryModal.controller';

let UninvoicedTimeEntryModalComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  size: 'lg',
  windowClass: "hmodal-warning animated zoomIn"
};

export default UninvoicedTimeEntryModalComponent;



// WEBPACK FOOTER //
// ./client/common/modals/UninvoicedTimeEntryModal/uninvoicedTimeEntryModal.component.js